import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "../../../../../../../redux/store";
import type { ToReviewFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveToReviewFundingRequests = createAsyncThunk<ToReviewFundingRequestVM[], void, { extra: Partial<Dependencies> }>(
  "fundingRequests/retrieveToReviewFundingRequests",
  async (_: void, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({ status: ["to_review"] });
    const response: ToReviewFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "to_review") {
        response.push(r);
      }
    }
    return response;
  },
);
